<template>
	<div class="popup popup--medium" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Добавить представителя</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="popup__form">
					<div class="info-list">
						<div class="info-list__item">
							<div class="info-item">
								<div class="info-item__el">
									<InputText label="Имя *" placeholder="Введите имя" v-model="formData.name" :errors="v$.formData.name.$errors"/>
								</div>
								<div class="info-item__el">
									<InputText label="Фамилия *" placeholder="Введите фамилию"  v-model="formData.lastName" :errors="v$.formData.lastName.$errors"/>
								</div>
								<div class="info-item__el">
									<InputText label="Отчество *" placeholder="Введите отчество"  v-model="formData.secondName" :errors="v$.formData.secondName.$errors"/>
								</div>
								<div class="info-item__el info-item__el--2">
									<InputText label="E-mail *" placeholder="Введите E-mail" v-model="formData.email" :errors="v$.formData.email.$errors"/>
								</div>
							</div>
						</div>
						<div class="info-list__item">
							<div class="info-item">
								<div class="info-item__el info-item__el--3">
									<InputMultiplyPhone v-model="formData.phones"/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="popup__btns">
					<button class="btn btn--color" @click.prevent="sendForm">Добавить</button>
					<button class="btn btn--border" @click="$emit('close')">Отмена</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Fetch from "@/utils/Fetch";
import {useToast} from "vue-toastification";
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputMultiplyPhone from "@/components/base/utils/formElements/InputMultiplyPhone.vue";
import useVuelidate from "@vuelidate/core";
import {required, helpers, email, minLength, maxLength} from '@vuelidate/validators'
const {withMessage} = helpers
import objectToFormData from "@/utils/ObjectToFormData";

export default {
	name: 'AddBlackListPopup',
	props: {
		supplier: {
			type: Object,
			default: () => {}
		},
	},
	components: {
		InputText,
		InputMultiplyPhone
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			toast: useToast(),
			formData: {
				name: '',
				lastName: '',
				secondName: '',
				email: '',
				phones: []
			}
		}
	},
	methods: {
		async sendForm() {
			const validated = await this.v$.$validate()
			if (!validated) {
				return
			}
			const body = objectToFormData({
				id: this.supplier.id,
				email: this.formData.email,
				phones: this.formData.phones,
				name: this.formData.name,
				lastName: this.formData.lastName,
				secondName: this.formData.secondName
			})
			let response = await Fetch(`/suppliers/add-account/`, {
				method: 'POST',
				body
			})
			if(response.success) {
				this.toast.success('Для поставщика добавлен представитель');
				this.$emit('close')
				this.$emit('refreshList')
			} else {
				this.toast.error(response.message);
				this.$emit('close')
			}
		},
	},
	validations() {
		return {
			formData: {

				name: {
					required: withMessage("Заполните имя", required),
					minLength: withMessage("В имени должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В имени должно быть максимум 30 букв", maxLength(30)),
				},
				lastName: {
					required: withMessage("Заполните фамилию", required),
					minLength: withMessage("В фамилии должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В фамилии должно быть максимум 30 букв", maxLength(30)),
				},
				secondName: {
					required: withMessage("Заполните отчество", required),
					minLength: withMessage("В отчестве должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В отчестве должно быть максимум 30 букв", maxLength(30)),
				},
				email: {
					required: withMessage('Заполните E-mail', required),
					email: withMessage('Неверный формат электронной почты', email),
				},
			}
		}
	},
}
</script>
